import '../css/index.scss';
import '../css/blog/blog.scss';
import Header from '../components/header';

new Header()